import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-nica-form-tabs',
  templateUrl: './nica-form-tabs.component.html',
  styleUrls: ['./nica-form-tabs.component.css']
})
export class NicaFormTabsComponent implements OnInit {
  /* ********************************************************** INPUT PROP ******************************************************************************** */
  @Input() configuration: { [key: string]: any } | undefined = undefined
  @Input() dataFields: { [key: string]: any }[] | undefined = undefined
  @Input() disableEditForm: boolean = false
  @Input() nCol: number = 1
  @Input() remoteOperation: boolean = true;
  @Input() api: string = ''
  @Input() service: string = ''
  @Input() isEdit: boolean = false;
  @Input() dataJson: any = undefined
  @Input() heightForm: number = undefined
  @Input() queryString: string = ''
  @Input() filterEditor: string = ''
  @Input() CustomButtonSetForm: any = undefined
  @Input() CustomButtonSetFormTop: any = undefined
  @Input() api_rest: boolean = false;
  @Input() masterKey: string = 'id';
  @Input() widthForm: number = undefined
  @Input() classe: string = '';
  @Input() nameSessionStorage: string = undefined
  @Input() remoteService: boolean = false
  @Input() toolbarTop: boolean = false
  @Input() toolbarBottom: boolean = false
  @Input() type: string = 'tabbed'
  /* ********************************************************** OUTPUT EVENT ******************************************************************************** */
  @Output() emittendButtonPush_FormTabs: EventEmitter<any> = new EventEmitter<any>();
  @Output() emittedItemsEvet_FormTabs: EventEmitter<any> = new EventEmitter<any>();
  @Output() emittedInitForm_FormTabs: EventEmitter<any> = new EventEmitter<any>();
  @Output() emittedDataSourceForm_FormTabs: EventEmitter<any> = new EventEmitter<any>();
  @Output() submitFormStep_FormTabs: EventEmitter<any> = new EventEmitter<any>();
  @Output() emittedDataGridEvent_FormTabs: EventEmitter<any> = new EventEmitter<any>();
  @Output() emittedAllEvent_FormTabs: EventEmitter<any> = new EventEmitter<any>();
  @Output() outDatiForm: EventEmitter<any> = new EventEmitter<any>();
  @Output() validationObj: EventEmitter<any> = new EventEmitter<any>();

  /* ********************************************************** PROP ******************************************************************************** */
  datiForm: { [key: string]: any[] } = {}
  /* ********************************************************************************************* */

  constructor() { }

  ngOnInit() {
    const isConfig = this.processConfig();
    if (isConfig) {
      this.queryString += this.processFiltro(this.filterEditor, this.dataJson)
    }
  }
  /* ********************************************************************************************* */
  //Emettono gli eventi al new-nica-form che lo contine
  /* ********************************************** NON USATI PER ORA *********************************************** */
  emittendButtonPush(event: any) {
    let evento = event
    if (typeof event === 'object') {
      evento['componentEmitter'] = 'NicaFormTabsComponent'
      evento['masterKey'] = this.masterKey
    } else {
      evento = {
        name: event,
        componentEmitter: 'NicaFormTabsComponent',
        masterKey: this.masterKey
      }
    }
    this.emittendButtonPush_FormTabs.emit(evento)
  }
  emittedDataSourceForm(event: any) {
    let evento = event
    if (typeof event === 'object') {
      evento['componentEmitter'] = 'NicaFormTabsComponent'
      evento['masterKey'] = this.masterKey
    } else {
      evento = {
        name: event,
        componentEmitter: 'NicaFormTabsComponent',
        masterKey: this.masterKey
      }
    }
    this.emittedDataSourceForm_FormTabs.emit(evento)
  }
  submitFormStep(event: any) {
    let evento = event
    if (typeof event === 'object') {
      evento['componentEmitter'] = 'NicaFormTabsComponent'
      evento['masterKey'] = this.masterKey
    } else {
      evento = {
        name: event,
        componentEmitter: 'NicaFormTabsComponent',
        masterKey: this.masterKey
      }
    }
    this.submitFormStep_FormTabs.emit(evento)
  }
  emittedAllEvent(event) {
    let evento = event
    if (typeof event === 'object') {
      evento['componentEmitter'] = 'NicaFormTabsComponent'
      evento['masterKey'] = this.masterKey
    } else {
      evento = {
        name: event,
        componentEmitter: 'NicaFormTabsComponent',
        masterKey: this.masterKey
      }
    }
    if (evento.name === "submitFormStatic") {
      this.outDatiForm.emit(evento)
      //console.log(event)
    }

    this.emittedAllEvent_FormTabs.emit(evento)

  }
  /* ********************************************************************************************* */
  //Emettono gli eventi al new-nica-form che lo contine ed emettono i nuovi dati al form cambiando solo i dataField legati alle chiavi
  /* ********************************************** USATI PER ORA *********************************************** */
  emittedItemsEvet(event: any) {
    let evento = event
    if (typeof event === 'object') {
      evento['componentEmitter'] = 'NicaFormTabsComponent'
      evento['masterKey'] = this.masterKey
    } else {
      evento = {
        name: event,
        componentEmitter: 'NicaFormTabsComponent',
        masterKey: this.masterKey
      }
    }
    if (event.name === "onValueChanged") {
      this.datiForm = event.formData;
      //console.log("onValueChanged----", this.datiForm)
      this.outDatiForm.emit({ newSet: this.datiForm, event: event, ...event, dataField: evento.campo.dataField })
    }
    this.emittedItemsEvet_FormTabs.emit(evento)
  }
  emittedInitForm(event: any) {
    let evento = event
    if (typeof event === 'object') {
      evento['componentEmitter'] = 'NicaFormTabsComponent'
      evento['masterKey'] = this.masterKey
    } else {
      evento = {
        name: event,
        componentEmitter: 'NicaFormTabsComponent',
        masterKey: this.masterKey
      }
    }
    if (event.name === "formContentInitializzed" && event.form) {
      this.datiForm = event.formData;
      //console.log("formContentInitializzed----", this.datiForm)
      this.outDatiForm.emit({ newSet: this.datiForm, event: event, ...event })//output dati a new-nica-form
    }
    this.emittedInitForm_FormTabs.emit(evento)
  }
  emittedDataGridEvent(event: any) {
    let evento = event
    if (typeof event === 'object') {
      evento['componentEmitter'] = 'NicaFormTabsComponent'
      evento['masterKey'] = this.masterKey
    } else {
      evento = {
        name: event,
        componentEmitter: 'NicaFormTabsComponent',
        masterKey: this.masterKey
      }
    }
    if (event.name === "gridHasInitialized" && event.dataSource) {
      this.datiForm[event.component.idTable] = event.dataSource;
      //console.log("gridHasInitialized----", this.datiForm)
      this.outDatiForm.emit({ newSet: this.datiForm, event: event, ...event }) //output dati a new-nica-form

    }
    if (event.name === "dataSourceChange" && event.data) {
      this.datiForm[event.masterComponent.idTable] = event.dataSource
      //console.log("dataSourceChange-------", this.datiForm)
      this.outDatiForm.emit({ newSet: this.datiForm, event: event, ...event })//output dati a new-nica-form

    }
    this.emittedDataGridEvent_FormTabs.emit(evento)
  }
  /* ********************************************************************************************* */
  //!-------------------------------------------------------------------------------------------------------------------
  private processConfig() {
    if (this.configuration) {
      Object.keys(this.configuration).forEach((key) => {
        if (this.hasOwnProperty(key)) {
          (this as any)[key] = this.configuration[key];
          ////console.log(`Chiave: ${key}`, (this as any)[key])
        }
      })
      return this.configuration !== undefined
    } else {
      return this.api !== '' && this.filterEditor !== ''
    }
  }
  private processFiltro(query: string, data: { [key: string]: any }) {
    //es. query= /$ oppure ?id=[id] oppure /$?id=[id]&&id=[id] oppure /[id]?id=[id]&&id=[id]
    if (this.masterKey && data.hasOwnProperty(this.masterKey)) {
      query = query.replace('$', data[this.masterKey]);
    }
    return query.replace(/\[([^\]]+)\]/g, (match, variable) => {
      return data.hasOwnProperty(variable) ? data[variable] : match;
    });
    //output= /1?id=1&&id=1
  }

}
